module.exports = __webpack_public_path__ + "static/media/ratings2.5df8d30c.jpg";